import { type LayerKey, resolveTopologicalPath } from '@festina-life/api'
import type { Optional } from '@festina-life/core'
import { useOpenPath } from '@festina-life/ui/listsAndTables'
import { useCallback } from 'react'

import { useMetaModelContext } from '../../context/metaModelContext'
import { useConfigurationItemsTreeId } from '../../scenes/serverConfigurationItems/useConfigurationItemsTreeId'

export const useOpenConfigurationPath = () => {
  const { layerTopology } = useMetaModelContext()
  const configurationItemsTreeId = useConfigurationItemsTreeId()
  const openPath = useOpenPath(configurationItemsTreeId)

  return useCallback(
    (layer: LayerKey, packageName?: Optional<string>) => {
      const allLayers = resolveTopologicalPath(layer, layerTopology)

      const [initialPackagePart, ...remainingPackageParts] = (
        packageName ?? ''
      ).split('.')

      const currentLayerId = layer.layerId
      const currentTenantId = layer.tenantId
      const itemPackageName =
        !currentTenantId &&
        currentLayerId?.localeCompare(initialPackagePart, undefined, {
          sensitivity: 'base',
        }) === 0
          ? remainingPackageParts.join('.')
          : packageName

      const layersPart = allLayers
        .map((itemLayer) => itemLayer.toString())
        .join('.')
      const itemPath = itemPackageName
        ? `${layersPart}.${itemPackageName}`
        : layersPart

      openPath(itemPath)
    },
    [layerTopology, openPath],
  )
}
